import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import ListaEndosos from "../../components/EndososBeneficiarios/ListaEndosos";


class EndososBeneficiarios extends React.Component {

    async componentDidMount() { 
    }

    render() {
        return (
            <main className="bg-light">
                <div className="cr-content container-fluid">
                    <div className="container-body-spaces">
                        <ListaEndosos/>
                    </div>
                </div>
            </main>
        );
    }
}

const mapStateToProps = (state) => ({
    datosUsuario: state.datosUsuarios.dataUsuario
});

const mapDispatchToProps = (dispatch) => {
    return {
    };
};

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(EndososBeneficiarios)
);